import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import {
  AppNotifications,
  FORM_MODE,
  RootState,
  LanguageOutputModel,
  CareerStatus,
  CareerOutputModel,
  TCb,
  UploadedImageModel,
} from "../../../models";
import { CareerService } from "../../../services";
import { NotificationActions } from "../../../store/actions";
import CareerFormPresenter from "./CareerForm.presenter";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./CareerForm.type";
import { ImageUtil, loadCallback } from "../../../utils";
import { withRouter } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

class CareerFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);

    this.state = {
      mode: FORM_MODE.CREATE,
      loading: false,
      initData: null,

      careerStatus: {
        status: false,
        timePublication: null,
      },
      isEditSalary: false,
      languageOptions: this.props.all_language_list.data,
      activeLang: this.props.all_language_list.data.find((e: LanguageOutputModel) => e.isPrimary)?.id,

      careerPictures: [],
    };
  }
  onChangeCareerStatus = (status: boolean) => {
    this.setState((prevState) => {
      return {
        careerStatus: {
          ...prevState.careerStatus,
          status,
        },
      };
    });
  };

  onChangeTimePublication = (date: string | null) => {
    this.setState((prevState) => {
      return {
        careerStatus: {
          ...prevState.careerStatus,
          timePublication: date,
        },
      };
    });
  };

  onUploadAvatar = (data: UploadedImageModel) => {
    const formData = new FormData();
    formData.append("image", data.file);
    CareerService.uploadImageCareer(formData)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.setState({
            careerPictures: [{ id: uuidv4(), src: ImageUtil.buildCareerImgSrc(res.data.data)!, alt: data.alt || "" }],
          });
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload career image failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload career image failed" });
      });
  };

  onRemoveAvatar = (fileId: string) => {
    const imgs = this.state.careerPictures.filter((p) => p.id !== fileId);
    this.setState({
      careerPictures: imgs,
    });
  };

  onSubmit = (val: any) => {
    if (!this.state.careerPictures.length) {
      this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Please choose an image " });
      return;
    }

    const img = this.state.careerPictures[0];
    let newArr: any[] = [];
    this.state.languageOptions.forEach((e) => {
      if (val[`title${e.id}`]) {
        let newObj = {
          languageId: e.id,
          title: val[`title${e.id}`] || null,
          vacancies: parseInt(val.vacancies),
          jobDescription: val[`jobDescription${e.id}`] || null,
          requirementsBenefits: val[`requirementsBenefits${e.id}`] || null,
          contactInformation: val[`contactInformation${e.id}`] || null,
          isEditSalary: this.state.isEditSalary,
          status: this.state.careerStatus.status ? CareerStatus.PUBLISH : CareerStatus.UNPUBLISH,
          closingDate: this.state.careerStatus.timePublication,
          country: val.country,
          city: val.city,
          educationLevel: val.educationLevel,
          maxSalary: val.maxSalary,
          minSalary: val.minSalary,
          currency: val.currency,
          avatar: ImageUtil.convertImgServerSrc(img.src, "career"),
        };

        const found = this.state.initData?.find((i) => i.languageId === e.id) || false;
        this.state.mode !== FORM_MODE.CREATE &&
          found &&
          Object.assign(newObj, {
            id: this.state.initData?.find((i) => i.languageId === e.id)?.id,
          });
        newArr.push(newObj);
      }
    });
    if (this.state.mode === FORM_MODE.CREATE) {
      this.onCreateCareer(newArr);
    } else {
      this.onUpdateCareer(newArr);
    }
  };

  onCreateCareer = (data) => {
    CareerService.createCareer(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Create career success",
          });
          loadCallback(this.props.onComplete_Create);
        } else if (res) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Create career failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Create career failed",
        });
      });
  };

  onLoadCareerDetail = (code: string, cb?: TCb) => {
    this.setState({ loading: true, initData: null }, () => {
      CareerService.getCareerByCode(code)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            const data: CareerOutputModel[] = res.data.data;

            data.forEach((item) => {
              const banner = item.avatar
                ? {
                    id: item.id,
                    src: ImageUtil.buildCareerImgSrc(item.avatar)!,
                    alt: item.avatar || "",
                  }
                : undefined;

              this.setState({
                careerPictures: banner ? [banner] : [],
              });
            });

            this.setState(
              {
                mode: FORM_MODE.EDIT,
                loading: false,
                initData: data,
                careerStatus: {
                  status: data[0].status === CareerStatus.PUBLISH,
                  timePublication: data[0].closingDate,
                },
                isEditSalary: data[0].isEditSalary,
              },
              () => {
                loadCallback(cb?.success);
              }
            );
          } else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Failed to load data",
            });
            this.props.history.goBack();
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Failed to load data",
          });
        });
    });
  };

  onUpdateCareer = (data) => {
    CareerService.updateCareer(this.props.careerCode!, data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Edit career success",
          });
          loadCallback(this.props.onComplete_Update);
        } else if (res) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Edit career failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Edit career failed",
        });
      });
  };

  onDeleteCareer = () => {
    CareerService.deleteCareer(this.props.careerCode!)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Delete career success",
          });
          loadCallback(this.props.onComplete_Delete);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Delete career failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Delete career failed",
        });
      });
  };

  onChangeLanguage = (id: string) => {
    this.setState({ activeLang: id });
  };

  onChangeEditSalaryStatus = (status: boolean) => {
    this.setState({ isEditSalary: status });
  };

  componentDidMount = () => {
    if (this.props.careerCode) {
      this.onLoadCareerDetail(this.props.careerCode);
    }
  };

  render() {
    return (
      <CareerFormPresenter
        {...this.props}
        {...this.state}
        onSubmit={this.onSubmit}
        onDeleteCareer={this.onDeleteCareer}
        onChangeLanguage={this.onChangeLanguage}
        onChangeTimePublication={this.onChangeTimePublication}
        onChangeCareerStatus={this.onChangeCareerStatus}
        onChangeEditSalaryStatus={this.onChangeEditSalaryStatus}
        onUploadAvatar={this.onUploadAvatar}
        onRemoveAvatar={this.onRemoveAvatar}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(CareerFormContainer)
);
